export default "__VITE_ASSET__D5s83ss$__"